"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndeterminateState = void 0;
const rc_js_util_1 = require("rc-js-util");
const e_pointer_event_type_1 = require("../internal-events/e-pointer-event-type");
const get_distance_between_pointer_events_1 = require("../util/get-distance-between-pointer-events");
class IndeterminateState {
    constructor(downEvent, options, providers, sharedState, lastClick) {
        this.downEvent = downEvent;
        this.options = options;
        this.providers = providers;
        this.sharedState = sharedState;
        this.lastClick = lastClick;
    }
    handleMouseEvent() {
        return null;
    }
    handlePointerEvent(eventType, chartEvent) {
        DEBUG_MODE && rc_js_util_1._Debug.runBlock(() => {
            rc_js_util_1._Debug.assert(this.downEvent !== chartEvent, "event must be cloned");
        });
        switch (eventType) {
            case e_pointer_event_type_1.EPointerEventType.Down:
                {
                    if (chartEvent.$event.pointerId !== this.downEvent.$event.pointerId) {
                        this.sharedState.clearAllHoveredEntities(chartEvent);
                        return this.providers.stateFactories.getPinchZoomingState(this.downEvent, chartEvent, this.options, this.providers, this.sharedState);
                    }
                    else {
                        return null;
                    }
                }
            case e_pointer_event_type_1.EPointerEventType.Move:
                {
                    if (this.downEvent.$event.pointerId !== chartEvent.$event.pointerId) {
                        return null;
                    }
                    return this.providers.stateFactories.getPanningState(chartEvent, this.options, this.providers, this.sharedState);
                }
            case e_pointer_event_type_1.EPointerEventType.Out:
                {
                    return this.providers.stateFactories.getIdleState(null, this.options, this.providers, this.sharedState);
                }
            case e_pointer_event_type_1.EPointerEventType.Up:
                {
                    if (this.isDoubleClick(chartEvent.$event)) {
                        this.sharedState.onDblClick(chartEvent);
                        return this.providers.stateFactories.getIdleState(null, this.options, this.providers, this.sharedState);
                    }
                    else {
                        this.sharedState.onClick(chartEvent);
                        return this.providers.stateFactories.getIdleState({ chartEvent: chartEvent, timestamp: performance.now() }, this.options, this.providers, this.sharedState);
                    }
                }
        }
        return rc_js_util_1._Production.assertValueIsNever(eventType);
    }
    isDoubleClick(upEvent) {
        if (this.options.doubleClickOptions == null) {
            // the feature is not enabled
            return false;
        }
        if (this.lastClick == null || this.downEvent.$event.pointerId !== upEvent.pointerId) {
            // down event, up event and the previous up event are not the same pointer
            return false;
        }
        if (performance.now() > this.lastClick.timestamp + this.options.doubleClickOptions.timeout) {
            // too much time has passed
            return false;
        }
        // compare based on up events only, gives the user a chance to change their mind
        if ((0, get_distance_between_pointer_events_1.getDistanceBetweenPointerEvents)(this.lastClick.chartEvent.$event, upEvent) > this.options.doubleClickOptions.maxRadius) {
            // too far apart
            return false;
        }
        // there is a vague chance they meant to double tap
        return true;
    }
}
exports.IndeterminateState = IndeterminateState;
//# sourceMappingURL=indeterminate-state.js.map